import React from "react";
import Navbar from "../components/Navbar";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";

function Blog() {
  return (
    <>
      <Navbar />
      <h1>Comming soon...</h1>
      <Newsletter />
      <Footer />
    </>
  );
}

export default Blog;
